import { OrganizationException } from '@/domain/organization/exception/OrganizationException'

export class OrganizationNameTakenException extends OrganizationException {
}
